import { useQuery } from "@apollo/react-hooks";

import { GET_PHOTO_SUBMISSIONS_COUNTS } from "./queries";

const useSubmissionsCounts = () => {
    const { data } = useQuery(GET_PHOTO_SUBMISSIONS_COUNTS);

    const pendingCount = (data && data.pending && data.pending.totalCount) || 0;

    const autoDeniedCount =
        (data && data.autoDenied && data.autoDenied.totalCount) || 0;

    const manuallyDeniedCount =
        (data && data.manuallyDenied && data.manuallyDenied.totalCount) || 0;

    const totalDeniedCount = autoDeniedCount + manuallyDeniedCount;

    return {
        pendingCount,
        autoDeniedCount,
        manuallyDeniedCount,
        deniedCount: totalDeniedCount
    };
};

export default useSubmissionsCounts;
